import {Alert} from '@mui/material';

import usePayment from '../../../hooks/providers/usePayment';
import ContactEmailsList from '../../contact/ContactEmailsList/ContactEmailsList';

const UnpaidInvoiceAlert = () => {
  const {isPartner, hasUnpaidInvoice, lastInvoiceUrl, subscriptionContactInfo} = usePayment();

  if (!hasUnpaidInvoice) return null;

  const mails = subscriptionContactInfo.split(',');
  const contactSentence = mails.length > 1 ? 'Contactez un des utilisateurs suivants :' : 'Contactez ';

  return (
    <Alert severity="error">
      {isPartner ? (
        <span>
          Un problème de paiement a eu lieu sur la dernière facture. {contactSentence} <ContactEmailsList /> pour le débloquer.
        </span>
      ) : (
        <>
          Veuillez finaliser <a href={lastInvoiceUrl}>votre paiement</a> pour continuer à profiter de nos services.
        </>
      )}
    </Alert>
  );
};

export default UnpaidInvoiceAlert;
